import { render, staticRenderFns } from "./trainingCreate.vue?vue&type=template&id=284a5537&scoped=true"
import script from "./trainingCreate.vue?vue&type=script&lang=js"
export * from "./trainingCreate.vue?vue&type=script&lang=js"
import style0 from "./trainingCreate.vue?vue&type=style&index=0&id=284a5537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a5537",
  null
  
)

export default component.exports